import api from './api'; // axios instance

const ClientService = {
  // Create a new client
  createClient: async (clientData) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.post('/api/clients', clientData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // Get all clients
  getClients: async () => {
    const token = localStorage.getItem('auth_token');
    const response = await api.get('/api/clients', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Assuming { status: true, clients: [...] }
  },

  // Get single client by ID
  getClientById: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.get(`/api/clients/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Assuming { status: true, client: {...} }
  },

  // Update client by ID
updateClient: async (id, clientData) => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('No authentication token found. Please log in.');
  }
  try {
    const response = await api.put(`/api/clients/${id}`, clientData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update client';
    throw new Error(message);
  }
},

  // Delete client by ID
  deleteClient: async (id) => {
    const token = localStorage.getItem('auth_token');
    const response = await api.delete(`/api/clients/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};

export default ClientService;